<template>
  <div>
    <v-flex xs12 class="mb-3">
      <h2 class="text-center mb-3">Måleravlesing</h2>
    </v-flex>
    <v-alert v-if="protocol.related_protocol" :value="true" color="success" type="success">
      Skjemaet er ferdig utfylt med nøklene som ble levert ut ved innflyttingsprotokoll
    </v-alert>
    <v-flex xs12 class="mb-2 mt-3">
      <meter-input-table
        v-model="stepValues.meterList"
        @update-fields="updateFields"
      ></meter-input-table>
    </v-flex>
    <v-flex xs12 v-if="config.info">
      <i v-html="config.info" />
    </v-flex>
    <v-divider></v-divider>
    <v-flex xs12 class="mb-3">
      <v-textarea box label="Andre kommentarer" v-model="stepValues.comment" @input="updateFields"></v-textarea>
    </v-flex>
    <ImageUploadBox :images="stepValues.images" :relatedImages="stepValues.relatedImages"></ImageUploadBox>
    <StepButtons @next-page="next" @previous-page="previous" :step="this" />
  </div>
</template>

<script>
import MeterInputTable from "../form/MeterInputTable.vue";
import step from "../../mixins/step";
export default {
  mixins: [step],
  components: { MeterInputTable},
  mounted: function() {
    if(this.protocol.related_protocol && this.stepValues) {
      if(this.stepValues.loadedFromRelated == null || this.stepValues.loadedFromRelated == undefined) {
        if(this.protocol.related_protocol.steps.meters.saved_values.meterList) {
          this.stepValues.loadedFromRelated = true
          let meterList = JSON.parse( JSON.stringify(this.protocol.related_protocol.steps.meters.saved_values.meterList))
          this.stepValues.meterList = meterList
        }
      }
    }
  }
}
</script>
